// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.walkthrough-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.88);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
}

.walkthrough-card {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 16px;
  padding: 24px 24px 20px;
  max-width: 860px;
  width: 100%;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);
}

.walkthrough-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.walkthrough-title {
  font-size: 17px;
  font-weight: 600;
  color: #fdfdfd;
  margin: 0;
}

.walkthrough-close {
  background: none;
  border: none;
  color: #666;
  font-size: 18px;
  cursor: pointer;
  line-height: 1;
  padding: 4px 8px;
  border-radius: 6px;
  transition: color 0.2s ease, background 0.2s ease;
}

.walkthrough-close:hover {
  color: #fdfdfd;
  background: rgba(255, 255, 255, 0.08);
}

/* 16:9 aspect ratio container */
.walkthrough-video-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 10px;
  overflow: hidden;
  background: #000;
}

.walkthrough-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}

@media (max-width: 640px) {
  .walkthrough-card {
    padding: 16px 16px 14px;
    border-radius: 12px;
  }

  .walkthrough-title {
    font-size: 15px;
  }
}

/* ── Picker modal (narrower, list state) ─────────────────── */

.walkthrough-picker-narrow {
  max-width: 520px;
}

.walkthrough-picker-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 420px;
  overflow-y: auto;
}

.walkthrough-picker-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: #111;
  border: 1px solid #2a2a2a;
  border-radius: 10px;
  padding: 14px 16px;
  transition: border-color 0.15s ease;
}

.walkthrough-picker-card:hover {
  border-color: #444;
}

.walkthrough-picker-card-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.walkthrough-picker-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #fdfdfd;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.walkthrough-picker-card-desc {
  font-size: 12px;
  color: #aeb9cc;
  line-height: 1.4;
}

.walkthrough-picker-watch-btn {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
  background: transparent;
  border: 1px solid #444;
  color: #aeb9cc;
  font-size: 12px;
  padding: 5px 13px;
  border-radius: 20px;
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;
}

.walkthrough-picker-watch-btn:hover {
  border-color: #218aff;
  color: #218aff;
}

/* Back button shown in playing state */
.walkthrough-back-btn {
  background: none;
  border: none;
  color: #aeb9cc;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 0;
  transition: color 0.2s ease;
}

.walkthrough-back-btn:hover {
  color: #fdfdfd;
}

/* Subtitle shown above iframe in playing state */
.walkthrough-playing-title {
  font-size: 13px;
  color: #aeb9cc;
  margin: 0 0 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/WalkthroughVideoModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,+DAA+D;;AAE/D;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".walkthrough-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.88);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 20px;\n}\n\n.walkthrough-card {\n  background: #1a1a1a;\n  border: 1px solid #333;\n  border-radius: 16px;\n  padding: 24px 24px 20px;\n  max-width: 860px;\n  width: 100%;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6);\n}\n\n.walkthrough-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 16px;\n}\n\n.walkthrough-title {\n  font-size: 17px;\n  font-weight: 600;\n  color: #fdfdfd;\n  margin: 0;\n}\n\n.walkthrough-close {\n  background: none;\n  border: none;\n  color: #666;\n  font-size: 18px;\n  cursor: pointer;\n  line-height: 1;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: color 0.2s ease, background 0.2s ease;\n}\n\n.walkthrough-close:hover {\n  color: #fdfdfd;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n/* 16:9 aspect ratio container */\n.walkthrough-video-wrapper {\n  position: relative;\n  width: 100%;\n  padding-top: 56.25%;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #000;\n}\n\n.walkthrough-iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n@media (max-width: 640px) {\n  .walkthrough-card {\n    padding: 16px 16px 14px;\n    border-radius: 12px;\n  }\n\n  .walkthrough-title {\n    font-size: 15px;\n  }\n}\n\n/* ── Picker modal (narrower, list state) ─────────────────── */\n\n.walkthrough-picker-narrow {\n  max-width: 520px;\n}\n\n.walkthrough-picker-list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 420px;\n  overflow-y: auto;\n}\n\n.walkthrough-picker-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  background: #111;\n  border: 1px solid #2a2a2a;\n  border-radius: 10px;\n  padding: 14px 16px;\n  transition: border-color 0.15s ease;\n}\n\n.walkthrough-picker-card:hover {\n  border-color: #444;\n}\n\n.walkthrough-picker-card-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.walkthrough-picker-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fdfdfd;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.walkthrough-picker-card-desc {\n  font-size: 12px;\n  color: #aeb9cc;\n  line-height: 1.4;\n}\n\n.walkthrough-picker-watch-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  flex-shrink: 0;\n  background: transparent;\n  border: 1px solid #444;\n  color: #aeb9cc;\n  font-size: 12px;\n  padding: 5px 13px;\n  border-radius: 20px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, color 0.2s ease;\n  white-space: nowrap;\n}\n\n.walkthrough-picker-watch-btn:hover {\n  border-color: #218aff;\n  color: #218aff;\n}\n\n/* Back button shown in playing state */\n.walkthrough-back-btn {\n  background: none;\n  border: none;\n  color: #aeb9cc;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 0;\n  transition: color 0.2s ease;\n}\n\n.walkthrough-back-btn:hover {\n  color: #fdfdfd;\n}\n\n/* Subtitle shown above iframe in playing state */\n.walkthrough-playing-title {\n  font-size: 13px;\n  color: #aeb9cc;\n  margin: 0 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
